$(document).ready(function () {
    let researchersGraph = new Swiper("#researchersGraph", {
        slidesPerView: "auto",
    });
});
